import axios from "axios";
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowAltCircleLeft,faCalendarAlt,
  faTimesCircle,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import {
  Collapse,
  CardBody,
  Card,
  CardHeader,
  Row,
  Col,
  Badge,
} from "reactstrap";
import { forEach } from "lodash";
import { Anchor } from "grommet";
import VideoComponent from "./LearnerAssesment/VideoComponent";
import MaterialComponent from "./LearnerAssesment/MaterialComponent";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Spinner from "../sample/spinner";
import Paper from "@material-ui/core/Paper";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import "../../css/course-page.css";
// const useStyles = makeStyles((theme) => ({
//   root: {
//     width: '100%',
//   },
//   heading: {
//     fontSize: theme.typography.pxToRem(15),
//     fontWeight: theme.typography.fontWeightRegular,
//   },
// }));
class Coursecontent extends Component {
  constructor(props) {
    super(props);
    const courseout = [];
    this.toggle = this.toggle.bind(this);
    this.state = {
      coursesmenu: true,
      currentid: null,
      isVisible: false,
      isreadmore: false,
      courseout,
      collapseBanner: "",
      collapseCycle: "",
      collapseReleaseDate: "",
      collapseLayout: "",
      setmyview: "",
      contentid: "",
      contenttype: "",
      videoid: "",
      materialid: "",
      materiapath: "",
      materialtype: "",
      showComponent: false,
      expanded: 0,
      expanded1: 0,
      initialvideo: "NA",
    };
    // this.mouseOver = this.mouseOver.bind(this);
    // this.mouseOut = this.mouseOut.bind(this);
  }

  componentDidMount() {
    this.getCourseContent();
  }
  handleChange = (panel) => (event, newExpanded) => {
    // setExpanded(newExpanded ? panel : false);
    if (newExpanded) {
      this.setState({
        expanded: panel,
      });
    } else {
      this.setState({
        expanded: false,
      });
    }
  };

  handleChange1 = (panel) => (event, newExpanded) => {
    // setExpanded(newExpanded ? panel : false);
    if (newExpanded) {
      this.setState({
        expanded1: panel,
      });
    } else {
      this.setState({
        expanded1: false,
      });
    }
  };
  toggle(e) {
    let event = e.target.dataset.event;
    let key = e.target.dataset.type;
    switch (key) {
      case "collapseBanner": {
        this.setState({
          collapseBanner: event,
          collapseCycle: "",
          collapseReleaseDate: "",
          collapseLayout: "",
        });
        break;
      }
      case "collapseCycle": {
        this.setState({
          collapseCycle: event,
          collapseReleaseDate: "",
          collapseLayout: "",
        });
        break;
      }
      case "collapseReleaseDate": {
        this.setState({
          collapseReleaseDate: event,
          collapseLayout: "",
          collapseCycle: "",
        });
        break;
      }
      case "collapseLayout": {
        this.setState({ collapseLayout: event });
        break;
      }
      default:
        break;
    }
  }
  async getCourseContent() {
    this.setState({ showComponent: true });
    let formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));
    axios
      .post("LearnerCourse/courseContent", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          this.setState({
            showComponent: false,
            courseout: res.data.courseout,
          });
          if (res.data.myfirstvideo !== "NA") {
            // console.log(res.data.myfirstvideodata)
            this.setState({
              setmyview: "video",
              contentid: res.data.myfirstvideodata.topicid,
              videoid: res.data.myfirstvideodata?.videoid,
              contenttype: "Topiclevel",
            });
          }
          // console.log(this.state.courseout);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }

  changeBackground(e, cid) {
    console.log("changeBackground =" + this.state.isreadmore + cid);
    this.setState({ isreadmore: !this.state.isreadmore, currentid: cid });
  }
  

  renderTopic(Topic) {
    let result = [];
    forEach(Topic, (topic, bannerId) => {
      result.push(
        // <Card style={{ marginBottom: "1rem" }} key={topic.topic}>
        //   <CardHeader
        //     onClick={this.toggle}
        //     data-event={topic.topic}
        //     data-type="collapseCycle"
        //   >
        //     {" "}
        //     {topic.topic}
        //   </CardHeader>
        //   <Collapse isOpen={this.state.collapseCycle === topic.topic}>
        //     <CardBody>{this.renderTopicContent(topic)}</CardBody>
        //   </Collapse>
        // </Card>

        <Accordion
          square
          expanded={this.state.expanded1 === bannerId}
          onChange={this.handleChange1(bannerId)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            className="typography-topic"
          >
            <Typography>
              <span> 
                {topic.topic.length <= 30 ? (
                  <> {topic.topic}1</>
                ) : (
                  <>
                    {this.state.currentid === topic.topicid &&
                    this.state.isreadmore === true ? (
                      <>
                        {" "}
                        {topic.topic}  &nbsp;
                        <button
                          onMouseEnter={(e) =>
                            this.changeBackground(e, topic.topicid)
                          }
                        
                          style={{
                            "background-color": "#dfefff",
                            color: "blue",
                            border: "none",
                          }}   class="rotate-inner"
                        >
                          ..Read Less
                        </button>{" "}
                      </>
                    ) : (
                      <>
                        {topic.topic.slice(0, 30)}{" "} &nbsp;
                        <button
                          onMouseEnter={(e) =>
                            this.changeBackground(e, topic.topicid)
                          }
                         
                          style={{
                            "background-color": "#dfefff",
                            color: "blue",
                            border: "none",
                          }}   class="rotate-inner"
                        >
                          ..Read More
                        </button>
                      </>
                    )}
                  </>
                )}
              </span>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div id="style-6" class="desc scrollbartopiccontent">
                <span class="force-overflowtopiccontent">
                  {this.renderTopicContent(topic)}
                </span>
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
      );
    });
    return result;
  }

  renderTopicContent(topicContent) {
    let result = [];
    result.push(
      <>
        {topicContent.coursevideotopic &&
        topicContent.coursevideotopic.length > 0 ? (
          <>
            {/* <AccordionSummary
              aria-controls="panel1a-content"
              id="panel1a-header"
            > */}
            {/* <Typography> 
               <img src="/assets/images/icons/vmms_video.svg" alt="vmms_video" /> ({topicContent?.coursevideotopic.length})
            </Typography> */}
            {/* </AccordionSummary> */}

            <Typography>
              {topicContent.coursevideotopic.map((sub) => (
                <Anchor
                  onClick={(e) => {
                    this.setState({
                      setmyview: "video",
                      contentid: topicContent.topicid,
                      videoid: sub?.videoid,
                      contenttype: "Topiclevel",
                    });
                    window.scrollTo(0, 0);
                  }}
                >
                  <CardHeader>
                    <img
                      src="/assets/images/icons/vmms_video.svg"
                      alt="vmms_video"
                      width="23"
                      height="23"
                    />
                    &nbsp; 
                    {sub.metadata.length <= 30 ? (
                            <> {sub.metadata}</>
                          ) : (
                            <>
                              {this.state.currentid === sub.videoid &&
                              this.state.isreadmore === true ? (
                                <>
                                  {" "}
                                  {sub.metadata} &nbsp;
                                  <button
                                    onMouseEnter={(e) =>
                                      this.changeBackground(e, sub.videoid)
                                    }
                                   
                                    style={{
                                      "background-color": "#dfefff",
                                      color: "blue",
                                      border: "none",
                                    }}   class="rotate-inner"
                                  >
                                    ..Read Less
                                  </button>{" "}
                                </>
                              ) : (
                                <>
                                  {sub.metadata.slice(0, 30)}{" "}
                                  &nbsp;<button
                                    onMouseEnter={(e) =>
                                      this.changeBackground(e, sub.videoid)
                                    }
                                   
                                    style={{
                                      "background-color": "#dfefff",
                                      color: "blue",
                                      border: "none",
                                    }}   class="rotate-inner"
                                  >
                                    ..Read More
                                  </button>
                                </>
                              )}
                            </>
                          )}


                    <span style={{float:"right"}}><FontAwesomeIcon
                                                    icon={faCalendarAlt}
                                                    color="#0056b3"
                                                  /> &nbsp; {sub.metacreatdate}</span>
                           
                  </CardHeader>
                </Anchor>
              ))}
            </Typography>

            {/* <Card style={{ marginBottom: "1rem" }}>
              <CardHeader
                onClick={this.toggle}
                data-event={topicContent?.coursevideotopicid}
                data-type="collapseLayout"
              >
                Topic video ({topicContent?.coursevideotopic.length})
              </CardHeader>
              <Collapse
                isOpen={
                  this.state.collapseLayout === topicContent?.coursevideotopicid
                }
              >
                <CardBody>
                  {topicContent.coursevideotopic.map((sub) => (
                    <Anchor
                      onClick={(e) =>
                        this.setState({
                          setmyview: "video",
                          contentid: topicContent.topicid,
                          videoid: sub?.videoid,
                          contenttype: "Topiclevel",
                        })
                      }
                    >
                      <CardHeader>{sub.metadata}</CardHeader>
                    </Anchor>
                  ))}
                </CardBody>
              </Collapse>
            </Card> */}
          </>
        ) : (
          ""
        )}
        {topicContent.courseMaterialTopic &&
        topicContent.courseMaterialTopic.length > 0 ? (
          <>
            {/* <AccordionSummary
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>
                <img
                  src="/assets/images/icons/vmms_material.svg"
                  alt="vmms_video"
                />
                ({topicContent?.courseMaterialTopic.length})
              </Typography>
            </AccordionSummary> */}
            <Typography>
              {" "}
              {topicContent.courseMaterialTopic.map((sub) => (
                <>
                  {sub?.extension != null ? (
                    <Anchor
                      onClick={(e) => {
                        this.setState({
                          setmyview: "material",
                          contentid: topicContent.topicid,
                          materialid: sub?.materialid,
                          materialtype: sub?.extension,
                          materialpath: sub?.filepath,
                          contenttype: "Topiclevel",
                        });
                        window.scrollTo(0, 0);
                      }}
                    >
                      <Card>
                        <CardHeader>
                          <img
                            src="/assets/images/icons/vmms_material.svg"
                            alt="vmms_video"
                            width="23"
                            height="23"
                          />{" "}
                          &nbsp;
                          {sub.materialname.length <= 30 ? (
                            <> {sub.materialname}</>
                          ) : (
                            <>
                              {this.state.currentid === sub.materialid &&
                              this.state.isreadmore === true ? (
                                <>
                                  {" "}
                                  {sub.materialname} &nbsp;
                                  <button
                                    onMouseEnter={(e) =>
                                      this.changeBackground(e, sub.materialid)
                                    }
                                   
                                    style={{
                                      "background-color": "#dfefff",
                                      color: "blue",
                                      border: "none",
                                    }}   class="rotate-inner"
                                  >
                                    ..Read Less
                                  </button>{" "}
                                </>
                              ) : (
                                <>
                                  {sub.materialname.slice(0, 30)}{" "}
                                  &nbsp;<button
                                    onMouseEnter={(e) =>
                                      this.changeBackground(e, sub.materialid)
                                    }
                                   
                                    style={{
                                      "background-color": "#dfefff",
                                      color: "blue",
                                      border: "none",
                                    }}   class="rotate-inner"
                                  >
                                    ..Read More
                                  </button>
                                </>
                              )}
                            </>
                          )}
                          <span style={{float:"right"}}><FontAwesomeIcon
                                                    icon={faCalendarAlt}
                                                    color="#0056b3"
                                                  /> &nbsp;{sub.materialupdationdate}</span>
                           
                        </CardHeader>
                      </Card>
                    </Anchor>
                  ) : (
                    <>
                      <Card>
                        <CardHeader>
                          {" "}
                        
                          <a href={sub.material_link} target="_blank">
                            {sub.materialname.length <= 30 ? (
                              <> {sub.materialname} </>
                            ) : (
                              <>
                                {this.state.currentid === sub.materialid &&
                                this.state.isreadmore === true ? (
                                  <>
                                    {sub.materialname} &nbsp;
                                    <button
                                      onMouseEnter={(e) =>
                                        this.changeBackground(e, sub.videoid)
                                      }
                                     
                                      style={{
                                        "background-color": "#dfefff",
                                        color: "blue",
                                        border: "none",
                                        
                                      }}
                                      class="rotate-inner"
                                    >
                                      ..Read Less
                                    </button>{" "}
                                  </>
                                ) : (
                                  <>
                                    {sub.materialname.slice(0, 30)} &nbsp;
                                    <button
                                      onMouseEnter={(e) =>
                                        this.changeBackground(e, sub.materialid)
                                      }
                                     
                                      style={{
                                        "background-color": "#dfefff",
                                        color: "blue",
                                        border: "none",
                                      }} class="rotate-inner"
                                    >
                                      ..Read More
                                    </button>
                                  </>
                                )}
                              </>
                            )}
                              <span style={{float:"right"}}><FontAwesomeIcon
                                                    icon={faCalendarAlt}
                                                    color="#0056b3"
                                                  />&nbsp; {sub.materialupdationdate}</span>
                           
                          </a>
                        </CardHeader>
                      </Card>{" "}
                      <br />
                    </>
                  )}
                </>
              ))}
            </Typography>

            {/* <Card style={{ marginBottom: "1rem" }}>
              <CardHeader
                onClick={this.toggle}
                data-event={topicContent?.courseMaterialTopicid}
                data-type="collapseLayout"
              >
                Topic Material ({topicContent?.courseMaterialTopic.length})
              </CardHeader>
              <Collapse
                isOpen={
                  this.state.collapseLayout ===
                  topicContent?.courseMaterialTopicid
                }
              >
                <CardBody>
                  {topicContent.courseMaterialTopic.map((sub) => (
                    <>
                      {sub?.extension != null ? (
                        <Anchor
                          onClick={(e) =>
                            this.setState({
                              setmyview: "material",
                              contentid: topicContent.topicid,
                              materialid: sub?.materialid,
                              materialtype: sub?.extension,
                              materialpath: sub?.filepath,
                              contenttype: "Topiclevel",
                            })
                          }
                        >
                          <Card>
                            <CardHeader>{sub.materialname}</CardHeader>
                          </Card>
                          <br />
                        </Anchor>
                      ) : (
                        <>
                          <Card>
                            <CardHeader>
                              {" "}
                              {
                                // eslint-disable-next-line
                              }
                              <a href={sub.material_link} target="_blank">
                                {sub.materialname}
                              </a>
                            </CardHeader>
                          </Card>{" "}
                          <br />
                        </>
                      )}
                    </>
                  ))}
                </CardBody>
              </Collapse>
            </Card> */}
          </>
        ) : (
          ""
        )}
      </>
    );

    return result;
  }
  renderCourse(course) {
    let result = [];
    result.push(
      // <Card
      //   style={{ marginBottom: "1rem" }}
      //   key={course.courseoutline_courselevel}
      // >
      //   <CardHeader
      //     onClick={this.toggle}
      //     data-event={course.courseoutline_courselevel}
      //     data-type="collapseReleaseDate"
      //   >
      //     {"Unit Level Content"}
      //   </CardHeader>
      //   <Collapse
      //     isOpen={
      //       this.state.collapseReleaseDate === course.courseoutline_courselevel
      //     }
      //   >
      //     <CardBody>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className="typography-unit"
        >
          <Typography>{"Unit Level Content"}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            {course.courseLevelvideo.length > 0 ? (
              <>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className="typography-topic"
                  >
                    <Typography>
                      {" "}
                      Unit Level video ({course.courseLevelvideo.length})
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      <div id="style-6" class="desc scrollbartopiccontent">
                        <span class="force-overflowtopiccontent">
                          {course.courseLevelvideo.map((sub) => (
                            <Anchor
                              onClick={(e) =>
                                this.setState({
                                  setmyview: "video",
                                  contentid: course.courseid,
                                  videoid: sub?.videoid,
                                  contenttype: "Unitlevel",
                                })
                              }
                            >
                              <CardHeader>{sub.metadata}</CardHeader>
                            </Anchor>
                          ))}
                        </span>
                      </div>
                    </Typography>
                  </AccordionDetails>
                </Accordion>

                {/* <Card style={{ marginBottom: "1rem" }}>
                  <CardHeader
                    onClick={this.toggle}
                    data-event={course?.courseoutline_courselevel}
                    data-type="collapseLayout"
                  >
                    Unit Level video ({course.courseLevelvideo.length})
                  </CardHeader>
                  <Collapse
                    isOpen={
                      this.state.collapseLayout ===
                      course?.courseoutline_courselevel
                    }
                  >
                    <CardBody>
                      {course.courseLevelvideo.map((sub) => (
                        <Anchor
                          onClick={(e) =>
                            this.setState({
                              setmyview: "video",
                              contentid: course.courseid,
                              videoid: sub?.videoid,
                              contenttype: "Unitlevel",
                            })
                          }
                        >
                          <CardHeader>{sub.metadata}</CardHeader>
                        </Anchor>
                      ))}
                    </CardBody>
                  </Collapse>
                </Card> */}
              </>
            ) : (
              ""
            )}
            {course.courseLevelMaterial.length > 0 ? (
              <>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>
                      {" "}
                      Unit Level Material ({course.courseLevelMaterial.length})
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      <div id="style-6" class="desc scrollbartopiccontent">
                        <span class="force-overflowtopiccontent">
                          {course.courseLevelMaterial.map((sub) => (
                            <>
                              {sub?.extension != null ? (
                                <Anchor
                                  onClick={(e) =>
                                    this.setState({
                                      setmyview: "material",
                                      contentid: course.courseid,
                                      materialid: sub?.materialid,
                                      materialtype: sub?.extension,
                                      materialpath: sub?.filepath,
                                      contenttype: "Unitlevel",
                                    })
                                  }
                                >
                                  <Card>
                                    <CardHeader>{sub.materialname}</CardHeader>
                                  </Card>
                                  <br />
                                </Anchor>
                              ) : (
                                <>
                                  <Card>
                                    <CardHeader>
                                      {" "}
                                      {
                                        // eslint-disable-next-line
                                      }
                                      <a
                                        href={sub.material_link}
                                        target="_blank"
                                      >
                                        {sub.materialname}
                                      </a>
                                    </CardHeader>
                                  </Card>{" "}
                                  <br />
                                </>
                              )}
                            </>
                          ))}
                        </span>
                      </div>
                    </Typography>
                  </AccordionDetails>
                </Accordion>

                {/* <Card style={{ marginBottom: "1rem" }}>
                  <CardHeader
                    onClick={this.toggle}
                    data-event={course?.courseLevelMaterial_id}
                    data-type="collapseLayout"
                  >
                    Unit Level Material ({course.courseLevelMaterial.length})
                  </CardHeader>
                  <Collapse
                    isOpen={
                      this.state.collapseLayout ===
                      course?.courseLevelMaterial_id
                    }
                  >
                    <CardBody>
                      {course.courseLevelMaterial.map((sub) => (
                        <>
                          {sub?.extension != null ? (
                            <Anchor
                              onClick={(e) =>
                                this.setState({
                                  setmyview: "material",
                                  contentid: course.courseid,
                                  materialid: sub?.materialid,
                                  materialtype: sub?.extension,
                                  materialpath: sub?.filepath,
                                  contenttype: "Unitlevel",
                                })
                              }
                            >
                              <Card>
                                <CardHeader>{sub.materialname}</CardHeader>
                              </Card>
                              <br />
                            </Anchor>
                          ) : (
                            <>
                              <Card>
                                <CardHeader>
                                  {" "}
                                  {
                                    // eslint-disable-next-line
                                  }
                                  <a href={sub.material_link} target="_blank">
                                    {sub.materialname}
                                  </a>
                                </CardHeader>
                              </Card>{" "}
                              <br />
                            </>
                          )}
                        </>
                      ))}
                    </CardBody>
                  </Collapse>
                </Card> */}
              </>
            ) : (
              ""
            )}
          </Typography>
        </AccordionDetails>
      </Accordion>
      //     </CardBody>
      //   </Collapse>
      // </Card>
    );
    return result;
  }

  renderOutline() {
    let result = [];
    forEach(this.state.courseout, (courseout, bannerId) => {
      result.push(
        <Accordion
          square
          expanded={this.state.expanded === bannerId}
          onChange={this.handleChange(bannerId)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>{courseout.course.courseoutline}</Typography>
          </AccordionSummary>

          <AccordionDetails>
            <Typography>
              {courseout.Topic.length > 0 ? (
                <>{this.renderTopic(courseout.Topic)}</>
              ) : (
                <p class="notopic">No Contents Available For This Unit</p>
              )}
              {(courseout.course.courseLevelvideo &&
                courseout.course.courseLevelvideo.length > 0) ||
              (courseout.course.courseLevelMaterial &&
                courseout.course.courseLevelMaterial.length > 0) ? (
                <>{this.renderCourse(courseout.course)}</>
              ) : (
                ""
              )}
            </Typography>
          </AccordionDetails>
        </Accordion>

        // <Card
        //   style={{ marginBottom: "1 rem", background: " rgba(29,124,248,.05)" }}
        //   key={courseout.course.courseoutline}
        // >

        //   <CardHeader
        //     onClick={this.toggle}
        //     data-event={courseout.course.courseoutline}
        //     data-type="collapseBanner"
        //   >
        //     <p className="colle d-flex">
        //       <div className=" p-2 mr-auto font-weight-bold">
        //         <p className="card-header-sub">{courseout.course.courseoutline}</p>
        //       </div>
        //      1 <Anchor
        //         class="click-layer"
        //         onClick={this.toggle}
        //         data-event={courseout.course.courseoutline}
        //       ></Anchor>
        //     </p>

        //   </CardHeader>
        //   <Collapse
        //     isOpen={
        //       this.state.collapseBanner === courseout.course.courseoutline
        //     }
        //   >
        //     <CardBody>
        //       2{this.renderTopic(courseout.Topic)}
        //      3 {this.renderCourse(courseout.course)}
        //     </CardBody>
        //   </Collapse>
        // </Card>
      );
    });
    return result;
  }
  render() {
    return (
      <div>
        {this.state.showComponent === true ? (
          <>
            <Spinner />
          </>
        ) : (
          <>
            <Card className="bg-color-tab">
              {this.state.courseout.length === 0 ? (
                <>
                  <center>
                    <br /> <br />
                    <img
                      dir="images"
                      src="/assets/images/icons/no-course-content.svg"
                      alt=""
                      width="300"
                      height="150"
                      className="img-thumbnail"
                    />
                    <br /> <br />
                    <h6>" No Course content!"</h6>
                  </center>
                </>
              ) : (
                <>
                  {this.state.coursesmenu ? (
                    <Row>
                      <Col lg={7} className="container pt-2">
                        {/* <Card  className="p-3"> */}
                        {(() => {
                          switch (this.state.setmyview) {
                            case "video":
                              return (
                                <VideoComponent
                                  contentType={this.state.contenttype}
                                  contentId={this.state.contentid}
                                  videoid={this.state.videoid}
                                />
                              );
                            case "material":
                              return (
                                <MaterialComponent
                                  contentType={this.state.contenttype}
                                  contentId={this.state.contentid}
                                  materialid={this.state.materialid}
                                  materialtype={this.state.materialtype}
                                  materialpath={this.state.materialpath}
                                />
                              );
                            default:
                              return "";
                          }
                        })()}
                        {/* </Card> */}
                        {}
                      </Col>
                      <Col lg={5} className="bg-acc-white accordian">
                        <Paper className="p132-2">
                          Course Content
                          <FontAwesomeIcon
                            className="cross-icon"
                            icon={faTimesCircle}
                            onClick={() =>
                              this.setState({
                                coursesmenu: !this.state.coursesmenu,
                              })
                            }
                          />
                        </Paper>
                        <br />
                        <div id="style-6" class=" mr-te  desc scrollbarcontent">
                          <span class="force-overflowcontent ">
                            {this.renderOutline()}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col lg={12}>
                        <Badge
                          className="button-course-content-right"
                          color="light"
                          onClick={() =>
                            this.setState({
                              coursesmenu: !this.state.coursesmenu,
                            })
                          }
                        >
                          <FontAwesomeIcon
                            className="course-content-icon"
                            icon={faArrowAltCircleLeft}
                          />
                          <span className="course-content">
                            {" "}
                            Course Content
                          </span>
                        </Badge>{" "}
                        &nbsp; &nbsp; &nbsp; &nbsp;
                      </Col>
                      <Col lg={12}>
                        <div className="container">
                          <br />
                          {(() => {
                            switch (this.state.setmyview) {
                              case "video":
                                return (
                                  <VideoComponent
                                    contentType={this.state.contenttype}
                                    contentId={this.state.contentid}
                                    videoid={this.state.videoid}
                                  />
                                );
                              case "material":
                                return (
                                  <MaterialComponent
                                    contentType={this.state.contenttype}
                                    contentId={this.state.contentid}
                                    materialid={this.state.materialid}
                                    materialtype={this.state.materialtype}
                                    materialpath={this.state.materialpath}
                                  />
                                );
                              default:
                                return "";
                            }
                          })()}
                          {}
                        </div>
                      </Col>
                    </Row>
                  )}
                </>
              )}
            </Card>
          </>
        )}
      </div>
    );
  }
}

export default Coursecontent;
